import React, { Component } from 'react';
import '../../inc/genstyle.css';
import DateTimeFormats from '../../inc/date-time-format';
import IHeader from './ifragmentheader';
import ISidemenu from './ifragmentsidemenu';
import SearchIcon from '@mui/icons-material/Search';

const authKey = global.config.authBearerKey+"##"+global.config.kindcode[38];

class IClientChatHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
        stTitle: '',
        pageShow: '10',
        keyword: '',
        styleTb: 'table',
        data: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.deleteHandler = this.deleteHandler.bind(this);
    this.loadData = this.loadData.bind(this);
  }
  
  loadData() {
    console.log("loading...");
    document.getElementById('loading-area').style.display = 'block'; 
    var datatext ='{"keyword":"'+this.state.keyword+'","pageShow":"'+this.state.pageShow+'"}';
    var data = JSON.parse(datatext); 
    fetch(global.config.urlLink+"/clientchathistlist", {
        method: 'POST',
        //mode: 'no-cors', 
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': authKey,
        }, body : JSON.stringify(data)
    }).then(response => {
        if(response.status === 200) {
            console.log('response');
            console.log(response);
            return response.json()
        } else {
            console.log('Something happened wrong');
            console.log(response);
        }
    }).then(resJson => {
        document.getElementById('loading-area').style.display = 'none'; 
        console.log(resJson);
        //resJson = '{status: 200, values: { userEmail: "melia@point-star.com",userFullname: "Melia",userId: "111773733087018575892",userLevel: "Admin",userName: "melia@point-star.com",userPassword: ""}}';
        if(resJson.status === '200' && resJson.values.length > 0) { 
            // styleTb = 'table table-striped'; 
        
            var arrList = [];
            var arrSortByDesc = [];
            // var arrLicSortByAsc = [];
            for(var x=0; x<resJson.values.length; x++) {
                arrList.push({
                    docid: resJson.values[x].docid,
                    createdDate: resJson.values[x].createdate,
                    content: resJson.values[x].content
                })
                
            }
            if(arrList.length>0) {
                // arrLicSortByAsc = arrLicList.sort((c,d) => {
                //   return c.expireddate._seconds - d.expireddate._seconds;
                // })
                arrSortByDesc = arrList.sort((c,d) => {
                  return d.createdDate._seconds - c.createdDate._seconds;
                })
              }
            console.log(arrSortByDesc);
            this.setState({
                styleTb: 'table table-striped',
                data: arrSortByDesc,
            })
        } else {
            this.setState({
                styleTb: 'table',
                data: [],
            })
        } 
        
        // var styleTb = 'table';
        // if(resJson.status === '200' && resJson.values.length > 0) { styleTb = 'table table-striped'; } 
        // this.setState({
        //     styleTb: styleTb,
        //     data: resJson,
        //     isOpen: false,
        //     otherContent: ''
        // })
    }).catch(err => {
        document.getElementById('loading-area').style.display = 'none'; 
        console.log(err);
    });
  }
  handleChange(e) {
    this.setState({ [e.target.name] : e.target.value });
  }
  handleUserSelect = (e) => {
    const value = e.target.value;
    this.setState( prevState => {
        return {  
            ...prevState.pageShow, pageShow: value
        }
    })
  }
    
  handleSubmit(e) {
    e.preventDefault();
    this.loadData();
  }
  componentDidMount() {
    this.loadData();
  }
  render() {
    
    var clientChatHistList = [];
    if(this.state.data.length > 0) {
      for(var ls=0; ls < this.state.data.length; ls++) {
          var retResult = this.state.data[ls];
          var cDatez = "", cTimez="", reqContent="", resContent="";
          if(retResult.content.createDate !== undefined) {
              cDatez = DateTimeFormats(retResult.content.createDate._seconds,"date-short");
              cTimez = DateTimeFormats(retResult.content.createDate._seconds,"time-24-second");
          }
          if(retResult.content.requestContent !== undefined) {
              reqContent = retResult.content.requestContent;
            // msg = retResult.content.requestContent.substring(0,30);
            // if(retResult.content.requestContent.length > 30) { msg += "..."; }
          }
          if(retResult.content.responseContent !== undefined) {
            resContent = retResult.content.responseContent;
          }
          clientChatHistList.push(<tr key={retResult.docid}>
              <th scope="row-field">{ls+1}</th>
              <td>{cDatez}<br/>( {cTimez} )</td>
              <td>{retResult.content.memberName}</td>
              <td>{reqContent}</td>
              <td>{resContent}</td>
            </tr>)
      }
    } else {
        clientChatHistList.push(<tr key="1">
          <td colSpan="5" className="textCenter"><div className="mgT20 mgB20">:: no record ::</div></td>
        </tr>)
    }
   return (
    <div className="main-container">
      <div  className="header-main"><IHeader/></div>
          <div className="flex-container">
              <div className="sidebar-main"><ISidemenu/></div>
              <div className="main-content">
                <div className="stTitle">Helpdesk</div>
                <div className="stIndiTitle">List of history chat message from clients</div>
                <div className="mgT30">
                    {/*--*/}
                    <div className="content-container card card-body">
                        <div className="row show">
                            <div className="col-6 divMiddle">
                                <form method="post" id="search-form" className="form-inline" onSubmit={this.handleSubmit}>
                                    <div className="flex-container" style={{display:'none'}}>
                                        {/*<TextField id="keyword" name="keyword" label="Search entries.." type="search" variant="outlined" 
                                        value={this.state.keyword}
                                        onChange={this.handleChange.bind(this)}
                                        />*/}
                                        <input type="text" className="inputSearch mr-sm-2" name="keyword" id="keyword"
                                            placeholder="Search entries.."
                                            value={this.state.keyword}
                                            onChange={this.handleChange.bind(this)}/> 
                                        <SearchIcon style={{ fontSize: 35 }} className="iconGrey mgT05 cursor-on" onClick={this.handleChange.bind(this)}></SearchIcon>
                                    </div>
                                </form>
                            </div>
                            <div className="col-6 form-inline justify-content-end">
                            </div>
                        </div>
                        <div className="row-field mgT20">
                            <table className={this.state.styleTb}>
                            <thead>
                                <tr key="0">
                                <th scope="col">#</th>
                                <th scope="col">Date</th>
                                <th scope="col">Member Name</th>
                                <th scope="col">Message</th>
                                <th scope="col">Reply Message</th>
                                </tr>
                            </thead>
                            <tbody>
                                {clientChatHistList}
                            </tbody>
                            </table>
                        </div>
                        <div className="row mt-3">
                            <div className="col-6">
                                <div className="flex-container" style={{display:'none'}}>
                                    <div className="mgR20 divMiddle">Showing</div>
                                    <div className="mgR20 divMiddle show">
                                        <select className="btn btn-secondary" name="pageShow" 
                                            value={this.state.pageShow} 
                                            onChange={this.handleUserSelect}
                                            ref={(input) => this.textInputPageShow = input} >
                                            <option value="1">1</option>
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                    <div className="mgR20 divMiddle">list</div>
                                </div>
                            </div>
                            <div className="col-6 form-inline justify-content-end">
                                {/*<Pagination count={10} variant="outlined" shape="rounded" />*/}
                                {/*<nav className="row">
                                    <div className="col-12">
                                    <ul className="pagination justify-content-center">
                                        <li className="page-item">
                                        <a className="page-link" href="#!" aria-label="Previous">
                                            <span aria-hidden="true">&laquo;</span>
                                            <span className="sr-only">Previous</span>
                                        </a>
                                        </li>
                                        <li className="page-item active"><a class="page-link" href="#!">1</a></li>
                                        <li className="page-item"><a class="page-link" href="#!">2</a></li>
                                        <li className="page-item"><a class="page-link" href="#!">3</a></li>
                                        <li className="page-item">
                                        <a className="page-link" href="#!" aria-label="Next">
                                            <span aria-hidden="true">&raquo;</span>
                                            <span className="sr-only">Next</span>
                                        </a>
                                        </li>
                                    </ul>
                                    </div>
                                </nav>*/}
                            </div>
                        </div>
                    </div>
                    
                    {/*--*/}
                </div>
              </div>
          </div>
          <div id="loading-area" className="divHide loading"></div> 
    </div>
   );
  }
}
 
export default IClientChatHistory;